import { api } from '@/lib/axios'

export async function DadosFn() {
  const response = await api.get('dados')

  return response.data
}
